import { Controller } from '@hotwired/stimulus'

// Shows/hides a panel referenced by a CSS selector, remembering the choice in
// localStorage so it persists across visits. Defaults to open when nothing is
// stored. A control elsewhere in the DOM (e.g. a header button) gets its own
// controller instance; state lives on the panel element, so instances stay in
// sync.
export default class extends Controller {
  static values = { panel: String, storageKey: String }

  connect() {
    this.#apply(this.#stored === 'closed')
  }

  toggle() {
    const closed = !this.#closed
    this.#apply(closed)
    this.#store(closed ? 'closed' : 'open')
  }

  hide() {
    this.#apply(true)
    this.#store('closed')
  }

  #apply(closed) {
    this.#panel?.classList.toggle('hidden', closed)
  }

  get #closed() {
    return this.#panel?.classList.contains('hidden') ?? false
  }

  get #panel() {
    return this.hasPanelValue ? document.querySelector(this.panelValue) : null
  }

  get #stored() {
    if (!this.hasStorageKeyValue) return null

    try {
      return window.localStorage.getItem(this.storageKeyValue)
    } catch {
      return null
    }
  }

  #store(state) {
    if (!this.hasStorageKeyValue) return

    try {
      window.localStorage.setItem(this.storageKeyValue, state)
    } catch {
      // localStorage may be unavailable (e.g. private mode); ignore.
    }
  }
}
